import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {concatMap, of} from 'rxjs';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import { MenuApiService } from '../menu-api.service';
import { MenuStoreService } from '../menu-store.service';
import {ItemChildrenActions} from '@emm/menu/store/item-children/item-children.actions';

@Injectable({
    providedIn: 'root'
})
export class ItemChildrenEffects {

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ItemChildrenActions.load),
            withLatestFrom(
                this.store.queryConsumers.menuParamsContext$,
                this.store.queryFeatureScope.selected$,
                this.store.queryLocationSets.selectedVenue$
            ),
            concatMap(([{path}, {effectiveDate, menuKey}, featureScope, venue]) => {
                    if (venue && venue.name !== 'Base Location') {
                        return this.api.getMenuItemChildrenForVenue(menuKey.consumer, menuKey.location, venue.venueNumber,
                            path, effectiveDate)?.pipe(
                            map((items) => ItemChildrenActions.loadSuccess({path, items})),
                            catchError(({error}) => of(ItemChildrenActions.loadFailure({error})))
                        )
                    } else {
                        return this.api.getMenuItemChildrenByFeatureScope(featureScope, effectiveDate, menuKey, path)?.pipe(
                            map((items) => ItemChildrenActions.loadSuccess({path, items})),
                            catchError(({error}) => of(ItemChildrenActions.loadFailure({error})))
                        )
                    }
                }
            )
        )
    );

    constructor(
        private actions$: Actions,
        private api: MenuApiService,
        private store: MenuStoreService
    ) {}

}
